import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import Template from 'components/cases/listpage/hip/Template'

const Hip: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta
        keyword={
          'DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション'
        }
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/cases/hip'}
        title="組織開発・人材育成 | 事例 | Aitria（アイトリア）"
        description="組織開発・人材育成サービスのケーススタディを紹介します｜Aitria（アイトリア）はビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default Hip
